/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

// Force-register component overrides for this theme.
import './views/components/carticon.component';
import './views/components/price.component';
import './views/components/product.component';
import './views/components/product-v2.component';
import './views/components/promocode.component';

// TODO: Current build require at least one tsx file
export default () => <div />;
